import React from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';

const faqItems = [
  {
    question: "What makes your golf academy different from others?",
    answer: "Our academy uses a systematic coaching approach that moves away from traditional 'assembly line' training. We combine personalized coaching with cutting-edge technology, including 3D motion capture and AI-powered swing analysis, ensuring each golfer receives tailored training based on their unique biomechanics and goals."
  },
  {
    question: "How accurate are your golf simulators?",
    answer: "Our simulators use high-speed cameras and infrared sensors with millimeter accuracy. They track over 20 data points including ball speed, launch angle, spin rate, and club path. The technology is so precise that many professional golfers use similar systems for their training."
  },
  {
    question: "Do you offer custom club fitting for beginners?",
    answer: "Absolutely! In fact, we recommend custom fitting for golfers of all levels. Properly fitted clubs can significantly improve your game and prevent injuries. Our fitting process includes 3D body scanning, launch monitor data analysis, and expert consultation to ensure perfect equipment match."
  },
  {
    question: "What membership options do you offer?",
    answer: "We offer flexible membership tiers ranging from basic simulator access to premium packages including unlimited coaching, priority booking, and exclusive member events. Each tier is designed to meet different needs and budgets, with options for individuals, families, and corporate groups."
  },
  {
    question: "What's the best way to contact you for membership inquiries?",
    answer: 'For membership inquiries, please use the contact form or email membership@golf4i.com. You can also visit our facility for a personal tour and consultation.'
  },
  {
    question: 'Do I need to book appointments for golf lessons in advance?',
    answer: 'Yes, we recommend booking golf lessons at least 48 hours in advance to ensure coach availability. You can book through our website, mobile app, or by calling our academy desk.'
  },
  {
    question: 'What are your corporate event booking procedures?',
    answer: "Corporate events require advance booking. Please contact our events team with your requirements, preferred dates, and group size. We'll provide a customized proposal within 24 hours."
  },
  {
    question: 'Can I visit your facility without an appointment?',
    answer: 'Yes, our facility is open for walk-in visits during operating hours. For personalized tours or specific service consultations, we recommend scheduling an appointment.'
  },
  {
    question: 'How do I get updates about upcoming tournaments and events?',
    answer: 'Subscribe to our newsletter to receive regular updates about tournaments, events, and special offers. You can also follow us on social media for real-time updates.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major credit/debit cards, UPI payments, net banking, and cash. Corporate bookings can be made through bank transfers with proper documentation.'
  },
  {
    question: 'Do you offer beginner golf programs?',
    answer: 'Absolutely! We have specialized beginner programs that include equipment, basic training, and gradual skill development. Our certified instructors ensure a comfortable learning experience for all beginners.'
  },
  {
    question: 'What safety measures are in place at your facilities?',
    answer: 'We maintain high safety standards with regular equipment inspections, certified instructors, emergency protocols, and clean, well-maintained facilities.'
  }
];

const FAQ = () => (
  <>
    <section className="section-padding faq-page">
      <Container>
        <Row className="mb-5">
          <Col xs={12} className="text-center">
            <h1 className="section-title mb-3">Frequently Asked Questions</h1>
            <p className="section-subtitle">
              Quick answers to common questions about contacting us and our services.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <div className="faq-accordion card-modern p-3 p-md-4">
              <div className="faq-header text-center mb-4">
                <div className="faq-icon mb-3">❓</div>
                <h2 className="h4 text-green">Common Questions</h2>
                <p className="text-muted mb-0">Click on any question below to reveal the answer</p>
              </div>

              <Accordion flush className="faq-list">
                {faqItems.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={index} className="faq-item border-0 mb-2">
                    <Accordion.Header className="faq-question px-3 py-3">
                      <div className="faq-question-content d-flex align-items-center">
                        <div className="faq-number me-3">{index + 1}</div>
                        <span className="faq-question-text">{faq.question}</span>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="faq-answer px-3 py-3">
                      <div className="faq-answer-content d-flex">
                        <div className="faq-answer-icon me-3">💡</div>
                        <p className="mb-0">{faq.answer}</p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>

              <div className="faq-footer text-center mt-4 pt-3">
                <p className="text-muted mb-3">Still have questions? Contact us directly for personalized assistance.</p>
                <a href="/contact#contact-form" className="btn btn-gold">Ask Your Question</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>

    <style>{`
      .faq-page .faq-accordion { border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); }
      .faq-page .faq-header { padding: 1rem 0; }
      .faq-page .faq-icon { width: 60px; height: 60px; background-color: #f0f7f3; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 1.8rem; margin: 0 auto; }
      .faq-page .faq-item { border-radius: 8px; overflow: hidden; background: #f8f9fa; }
      .faq-page .faq-item:hover { background: #f0f7f3; }
      .faq-page .faq-question { background: transparent !important; border: none !important; box-shadow: none !important; color: #1F3D2B !important; font-weight: 600; }
      .faq-page .faq-question:not(.collapsed) { color: #B59A5A !important; }
      .faq-page .faq-question-content { width: 100%; }
      .faq-page .faq-number { width: 30px; height: 30px; background-color: #B59A5A; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600; flex-shrink: 0; }
      .faq-page .faq-question-text { flex: 1; line-height: 1.4; }
      .faq-page .faq-answer { background: #f8f9fa; border-top: 1px solid rgba(31, 61, 43, 0.1); color: #666; line-height: 1.6; }
      .faq-page .faq-answer-content { align-items: flex-start; }
      .faq-page .faq-answer-icon { width: 30px; height: 30px; background-color: #f0f7f3; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
      .faq-page .faq-footer { border-top: 1px solid rgba(31, 61, 43, 0.1); }
    `}</style>
  </>
);

export default FAQ;
